import Text from '@cartwhl/ui/base/Text';
import CameraIcon from '@cartwhl/ui/icons/CameraIcon';
import FileIcon from '@cartwhl/ui/icons/FileIcon';
import Button from '@cartwhl/ui/input/Button';

import { VideoFilePickerCompact } from 'components/VideoUploadModal';
import { navigationStore } from 'stores';

export default function VideoToMotion() {
  return (
    <div className="relative h-[154px] w-[300px] max-w-full rounded-b-lg rounded-t-2xl bg-white/80 lg:w-full">
      <VideoFilePickerCompact>
        <span />
      </VideoFilePickerCompact>

      <div className="text-gray-90 pointer-events-none absolute inset-0 flex h-full flex-col items-center justify-center gap-2">
        <div className="flex items-center gap-1.5">
          <FileIcon className="text-blue" />
          <Text variant="studio/body/medium/sm">
            <span className="text-blue">Select File</span>{' '}
            <span className="hidden md:inline">or drag and drop one here</span>
          </Text>
        </div>
        <Text
          variant="studio/body/medium/sm"
          className="text-gray-45 dark:text-gray-60"
        >
          or
        </Text>

        <Button
          variant="primary"
          size="sm"
          icon={<CameraIcon />}
          className="pointer-events-auto"
          onClick={() =>
            navigationStore.setVideoUploadModal({ mode: 'media capture' })
          }
        >
          Record new video
        </Button>
      </div>
    </div>
  );
}
